import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'react-app-polyfill/ie11';

import React from 'react';
import { AppRegistry } from 'react-native';
import { BrowserRouter } from 'react-router-dom';

import { THEME } from 'reactor/common';
import CUSTOM_THEME from 'common/theme';

THEME.extend(CUSTOM_THEME);

const App = require('./App').default;

const Router = () => (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

AppRegistry.registerComponent('App', () => Router);
AppRegistry.runApplication('App', {
  initialProps: {},
  rootTag: document.getElementById('root'),
});
